import { consoleApiSlice } from "./consoleApiSlice";

export const scanJourneySyncApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Push staging scan journeys (DB test_cases/test_results + S3 artifacts)
    // to the production Platform Backend. Console-orchestrated; long-running.
    pushScanJourneysToProd: builder.mutation({
      query: ({ scanId, prodWebsiteId }) => ({
        url: `/api/v1/scan-journeys/${scanId}/push-to-prod`,
        method: "POST",
        body: { prod_website_id: prodWebsiteId || null },
      }),
    }),
    // Finalize a staging->prod push: transfer Activity traces (check_steps ->
    // "pages seen") for each pushed scan, then trigger the prod regroup so the
    // bulk-upserted issues surface as findings/pattern cards. Called ONCE after
    // all issue batches. Long-running (regroup + multi-scan trace copy).
    finalizeProdPush: builder.mutation({
      query: ({
        prodWebsiteId,
        scanIds,
        notify = true,
        recipientEmails,
      }) => ({
        url: `/api/v1/scan-journeys/finalize-prod`,
        method: "POST",
        body: {
          prod_website_id: prodWebsiteId,
          scan_ids: scanIds || [],
          notify: notify !== false,
          ...(recipientEmails !== undefined
            ? { recipient_emails: recipientEmails }
            : {}),
        },
      }),
    }),
  }),
});

export const {
  usePushScanJourneysToProdMutation,
  useFinalizeProdPushMutation,
} = scanJourneySyncApiSlice;
